import styled, { css } from 'styled-components';
import { colors, fontWeight, screenSize } from 'styleGuide';

export const sharedArticleStyles = css`
  position: relative;
  display: flex;
  .header {
    color: ${colors.blue.primary};
    display: flex;
    align-items: center;
    .profile {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.87rem;
      .name {
        text-transform: uppercase;
        font-weight: ${fontWeight.fontHeavy};
      }
    }
  }
  @media (max-width: ${screenSize.mobileL}) {
    padding: 1.87rem;
  }
`;

export const ClientArticle = styled.article`
  background-color: ${colors.white};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  max-width: 68.75rem;
  padding: 3.13rem;
  margin: 0.94rem auto;
  ${sharedArticleStyles}
  @media (max-width: ${screenSize.mobileL}) {
    text-align: center;
    .profile {
      margin: 0 auto 1.88rem;
    }
  }
  @media (min-width: ${screenSize.mobileL}) {
    min-height: 24.25rem;
  }
`;

export const MomArticle = styled.article`
  background-color: ${colors.blue.pale};
  ${sharedArticleStyles}
  justify-content: center;
  align-items: center;
  .profile-pic-container {
    order: 1;
  }
  .testimony-content {
    order: 2;
  }
  @media (max-width: ${screenSize.laptop}) {
    padding: 0 4.37rem 0 3.12rem;
    .profile-pic-container {
      img {
        width: 18.75rem;
      }
    }
  }
  @media (min-width: ${screenSize.tablet}) {
    .testimony-content {
      max-width: 31.25rem;
    }
  }
  @media (max-width: ${screenSize.tablet}) {
    .profile-pic-container {
      img {
        width: 12.5rem;
      }
    }
  }
  @media (max-width: ${screenSize.mobileL}) {
    flex-direction: column;
    padding: 1.87rem 1.87rem 0;
    .profile-pic-container {
      order: 2;
      img {
        width: 20rem;
      }
    }
    .testimony-content {
      order: 1;
      text-align: center;
      .profile {
        width: 100%;
      }
    }
  }
`;

export const ProfilePicture = styled.img`
  width: 12.81rem;
  height: 15rem;
`;

export const MomProfilePicture = styled.img`
  width: 31.25rem;
  @media (max-width: ${screenSize.mobileL}) {
    width: 100%;
  }
`;
